import { goto } from '$app/navigation';
import { stateUi } from '@infinitro/config';
import { t, Verbiage } from '@infinitro/content';
import { formatCurrencyString, toastStore, toSiteUrl } from '@infinitro/global';
import { isBaseCurrency, walletsStore } from '@infinitro/global/wallet';
import { get } from 'svelte/store';
import { replaceTranslationsVars } from './replaceVars';
export function handleNotificationToast(notification) {
    const translate = get(t);
    const { notificationType, payload } = notification;
    if (!payload)
        return;
    const useExtendedDepositTitles = get(stateUi).notifications?.useExtendedDepositNotificationTitles === true;
    const cryptoAmount = formatCurrencyString(payload.amount, payload.currency);
    const tokenUpper = payload.currency?.toUpperCase();
    let tokenDisplay = tokenUpper;
    if (payload.currency && !isBaseCurrency(payload.currency)) {
        const wallet = get(walletsStore).find((w) => w.currency === payload.currency && !w.isBonus);
        if (wallet) {
            tokenDisplay = `${tokenUpper} (${wallet.toDisplayCurrencyString(payload.amount)})`;
        }
    }
    const vars = {
        AMOUNT: cryptoAmount,
        TOKEN: tokenDisplay
    };
    const depositSuccessTitle = useExtendedDepositTitles
        ? Verbiage.custom_deposit_success_notification_title
        : Verbiage.deposit_success_notification_title;
    const depositPendingTitle = useExtendedDepositTitles
        ? Verbiage.custom_deposit_pending_notification_title
        : Verbiage.deposit_pending_notification_title;
    switch (notificationType) {
        case 'DEPOSIT':
            if (payload.is_live === true && payload.amount && payload.currency) {
                if (payload.status?.toLowerCase() === 'completed') {
                    toastStore.addToast({
                        message: replaceTranslationsVars(translate(depositSuccessTitle), vars),
                        type: 'success',
                        action: () => {
                            goto(toSiteUrl('/transactions/deposits/'));
                        },
                        actionTitle: translate(Verbiage.view)
                    });
                }
                else if (payload.status?.toLowerCase() === 'confirming') {
                    toastStore.addToast({
                        message: replaceTranslationsVars(translate(depositPendingTitle), vars),
                        type: 'info',
                        action: () => {
                            goto(toSiteUrl('/transactions/deposits/'));
                        },
                        actionTitle: translate(Verbiage.view)
                    });
                }
            }
            break;
        case 'CHAT':
            break;
        case 'UI_NOTIFICATION':
            break;
        default:
            break;
    }
}
